module.exports = __webpack_public_path__ + "img/logo-icon4.410f88ff.png";